import client from '../../utils/api'
import { createSlice } from '@reduxjs/toolkit'
import { createApiAction } from '../../utils/redux-tool'

const name = 'leave-request-rollover'

const initialState = {
  list: null,
}

// Self mode — uses session person, no hr.rollover permission needed
export const searchSelf = createApiAction(
  'leave/leave-request-rollover/searchSelf',
  client.search('/api/leave/leave-request-rollover'),
)
export const saveSelf = createApiAction(
  'leave/leave-request-rollover/saveSelf',
  client.save('/api/leave/leave-request-rollover'),
)

// Manager / HR mode — staff/:personId, requires hr.rollover
export const search = createApiAction(
  'leave/leave-request-rollover/search',
  client.search('/api/leave/leave-request-rollover/staff/:personId'),
)
export const save = createApiAction(
  'leave/leave-request-rollover/save',
  client.save('/api/leave/leave-request-rollover/staff/:personId'),
)

const setList = (state, action) => { state.list = action.payload }

const sessionSlice = createSlice({
  name,
  initialState,
  reducers: {
    initLeaveRequestRollover: state => {
      state.list = null
    },
  },
  extraReducers(builder) {
    builder
      .addCase(search.fulfilled, setList)
      .addCase(save.fulfilled, setList)
      .addCase(searchSelf.fulfilled, setList)
      .addCase(saveSelf.fulfilled, setList)
  },
})

export const { initLeaveRequestRollover } = sessionSlice.actions
export default sessionSlice.reducer
